import { TableCell, TableRow, Typography } from "@material-ui/core";
import React from "react";
import { FiEdit } from 'react-icons/fi';
import { MdDeleteForever } from 'react-icons/md';
import { usePedidos } from "../../../../contexts/Pedidos";
import { useHistory } from 'react-router-dom';
import { useModals } from "../../../../contexts/Modals";
import { Button } from "../../../../themes/components/Button";
import { TextOnlyTooltip } from "../../../../themes/components/TextOnlyTooltip";

export function RowListaPrePedidos(props: { row: ReturnType<any>, index: number, atualizarTabela: () => void }) {
    const { row, atualizarTabela } = props;
    let history = useHistory();
    const { setMensagem, setShowModalInfo } = useModals();
    const { setIdPrePedido, deletarPrePedido } = usePedidos();
    const { mostrarInfoOK, setShowModalProgress, mostrarModalProgress } = useModals();
    const formatData = (text: string) => {
        let data = new Date(text);
        return (data.getUTCDate() < 10 ? '0' : '') + data.getUTCDate() + "/" + ((data.getUTCMonth() < 9 ? '0' : '') + String(data.getUTCMonth() + 1)) + "/" + data.getUTCFullYear()
    }

    function redirectTo(path: string) {
        history.push({
            pathname: process.env.PUBLIC_URL + path,
            state: { from: '/prepedidos/consultar' }
        });
    }

    function apagarPrePedido(id: number) {
        mostrarModalProgress("Deletando pré-pedido " + id);
        deletarPrePedido(id, history)
            .then(res => {
                setShowModalProgress(false);
                props.atualizarTabela();
            })
            .catch(err => {
                setShowModalProgress(false);
                mostrarInfoOK("Falha ao deletar pré-pedido", err);
            })
    }

    function confirmaEdicao() {
        setMensagem(
            <div className='mensagem-info-modal-loading'>
                <Typography>{`Deseja editar o pré-pedido ${row.id}?`}</Typography>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Button onClick={() => setShowModalInfo(false)} classBtn={"btn-notifications color-red"}>Cancelar</Button>
                    <Button onClick={() => [setShowModalInfo(false), setIdPrePedido(row.id), handleEditarPrePedido(row)]} classBtn={"btn-notifications color-default"}>Sim</Button>
                </div>
            </div>);
        setShowModalInfo(true);
    }

    async function handleEditarPrePedido(row: any) {
        //mostrarInfoOK("Função em manutenção!", "Atualização em breve!");
        history.push({
            pathname: `${process.env.PUBLIC_URL}/pedidos/novo`,
            state: {
                from: '/prepedidos/consultar',
                Pedido: row
            }
        });
    }

    function confirmaExclusao() {
        setMensagem(
            <div className='mensagem-info-modal-loading'>
                <Typography>{`Deseja excluir o pré-pedido ${row.id}?`}</Typography>
                <div style={{ display: 'flex' }}>
                    <Button onClick={() => setShowModalInfo(false)} classBtn={"btn-notifications color-default"}>Cancelar</Button>
                    <Button onClick={() => [setShowModalInfo(false), apagarPrePedido(row.id)]} classBtn={"btn-notifications color-red"}>Sim</Button>
                </div>
            </div>);
        setShowModalInfo(true);
    }

    return (
        <React.Fragment>
            <TableRow className={`linha_${props.index % 2 === 0 ? "par" : "impar"}`}>
                <TableCell scope="row" style={{ border: 'none' }} >{row.id}</TableCell>
                <TableCell align="left" style={{ border: 'none' }} >{row.cod_cliente + " - " + row.nome_cliente}</TableCell>
                <TableCell align="center" style={{ border: 'none' }} >{formatData(row.data_emissao)}</TableCell>
                <TableCell align="center" style={{ border: 'none' }} >{formatData(row.data_entrega)}</TableCell>
                <TableCell align="right" style={{ border: 'none' }} >{parseFloat(row.quantidade_total).toLocaleString('pt-br', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                <TableCell align="right" style={{ border: 'none' }} >{parseFloat(row.valor_total).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</TableCell>
                <TableCell align="right" width="50px" style={{ border: 'none' }} >
                    <TextOnlyTooltip title="Editar" placement="top">
                        <button style={{ backgroundColor: 'transparent', border: '0px' }} onClick={() => confirmaEdicao()} ><FiEdit size="22" color={"#003388"}/></button>
                    </TextOnlyTooltip>
                </TableCell>
                <TableCell align="right" width="50px" style={{ border: 'none' }} >
                    <TextOnlyTooltip title="Deletar" placement="top">
                        <button style={{ backgroundColor: 'transparent', border: '0px' }} onClick={() => confirmaExclusao()} ><MdDeleteForever size="27" color={"red"}/></button>
                    </TextOnlyTooltip>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

